import { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));

    useEffect(() => {
        let newSocket = io(process.env.REACT_APP_API_SOCKET_URL, {
            transports: ['websocket', 'polling'],
            auth: {
                authid: userDetails?.id,
            },
            // improved reconnection options
            autoConnect: true,
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            timeout: 20000,
        });

        setSocket(newSocket);

        return () => newSocket.disconnect();
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
export const useSocket = () => {
    return useContext(SocketContext);
};
